import liteApp from './liteApp'

export default [liteApp]
